import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'rect',
                attr: { width: '24', height: '24', rx: '12', fill: '#F0FAFF' },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M6.261 7.80005C6.117 7.80005 6 7.91705 6 8.06165V15.3654C6 15.5094 6.117 15.6264 6.261 15.6264H17.739C17.8836 15.6264 18 15.5094 18 15.3654V8.06165C18 7.91705 17.8836 7.80005 17.739 7.80005H6.261Z',
                    fill: '#1CC54F',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M8.34823 8.58313C8.34823 9.44713 7.64683 10.1479 6.78223 10.1479V13.2781C7.64683 13.2781 8.34823 13.9795 8.34823 14.8441H15.6526C15.6526 13.9795 16.3528 13.2781 17.2174 13.2781V10.1479C16.3528 10.1479 15.6526 9.44713 15.6526 8.58313H8.34823Z',
                    fill: '#B9F5B4',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M10.1738 11.7133C10.1738 12.7219 10.991 13.5397 11.9996 13.5397C13.0082 13.5397 13.826 12.7219 13.826 11.7133C13.826 10.7047 13.0082 9.88745 11.9996 9.88745C10.991 9.88745 10.1738 10.7047 10.1738 11.7133Z',
                    fill: '#1CC54F',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: false })) })));
};
const CircleCashColored = React.forwardRef(IconComponent);
CircleCashColored.displayName = 'CircleCashColored';

export { CircleCashColored };
